import script from "./VibeCodePromotionClassic.vue?vue&type=script&setup=true&lang=js"
export * from "./VibeCodePromotionClassic.vue?vue&type=script&setup=true&lang=js"

import "./VibeCodePromotionClassic.vue?vue&type=style&index=0&id=f6216e2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6216e2c"]])

export default __exports__